var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOnLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1613.18 630",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23);}.cls-2{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-2);}.cls-3{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-3);}.cls-4{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-4);}.cls-5{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-5);}.cls-6{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-6);}.cls-7{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-7);}.cls-8{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-8);}.cls-9{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-9);}.cls-10{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-10);}.cls-11{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-11);}.cls-12{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-12);}.cls-13{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-13);}.cls-14{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-14);}.cls-15{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-15);}.cls-16{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-16);}.cls-17{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-17);}.cls-18{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-18);}.cls-19{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-19);}.cls-20{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-20);}.cls-21{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-21);}.cls-22{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-22);}.cls-23{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-23);}.cls-24{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-24);}.cls-25{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-25);}.cls-26{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-26);}.cls-27{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-27);}.cls-28{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-28);}.cls-29{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-29);}.cls-30{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-30);}.cls-31{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-31);}.cls-32{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-32);}.cls-33{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-33);}.cls-34{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-34);}.cls-35{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-35);}.cls-36{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-36);}.cls-37{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-37);}.cls-38{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-38);}.cls-39{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-39);}.cls-40{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-40);}.cls-41{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-41);}.cls-42{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-42);}.cls-43{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-43);}.cls-44{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-44);}.cls-45{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-45);}.cls-46{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-46);}.cls-47{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-47);}.cls-48{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-48);}.cls-49{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-49);}.cls-50{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-50);}.cls-51{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-51);}.cls-52{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-52);}.cls-53{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-53);}.cls-54{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-54);}.cls-55{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-55);}.cls-56{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-56);}.cls-57{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-57);}.cls-58{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-58);}.cls-59{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-59);}.cls-60{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-60);}.cls-61{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-61);}.cls-62{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-62);}.cls-63{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-63);}.cls-64{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-64);}.cls-65{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-65);}.cls-66{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-66);}.cls-67{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-67);}.cls-68{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-68);}.cls-69{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-69);}.cls-70{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-70);}.cls-71{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-71);}.cls-72{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-72);}.cls-73{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-73);}.cls-74{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-74);}.cls-75{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-75);}.cls-76{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-76);}.cls-77{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-77);}.cls-78{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-78);}.cls-79{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-79);}.cls-80{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-80);}.cls-81{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-81);}.cls-82{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-82);}.cls-83{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-83);}.cls-84{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-84);}.cls-85{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-85);}.cls-86{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-86);}.cls-87{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-87);}.cls-88{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-88);}.cls-89{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-89);}.cls-90{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-90);}.cls-91{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-91);}.cls-92{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-92);}.cls-93{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-93);}.cls-94{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-94);}.cls-95{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-95);}.cls-96{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-96);}.cls-97{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-97);}.cls-98{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-98);}.cls-99{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-99);}.cls-100{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-100);}.cls-101{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-101);}.cls-102{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-102);}.cls-103{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-103);}.cls-104{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-104);}.cls-105{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-105);}.cls-106{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-106);}.cls-107{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-107);}.cls-108{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-108);}.cls-109{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-109);}.cls-110{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-110);}.cls-111{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-111);}.cls-112{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-112);}.cls-113{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-113);}.cls-114{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-114);}.cls-115{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-115);}.cls-116{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-116);}.cls-117{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-117);}.cls-118{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-118);}.cls-119{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-119);}.cls-120{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-120);}.cls-121{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-121);}.cls-122{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-122);}.cls-123{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-123);}.cls-124{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-124);}.cls-125{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23-125);}.cls-126{fill:#333;}.cls-127{fill:#76767a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23",
    x1: 176.07,
    y1: 619.72,
    x2: 564.67,
    y2: 231.12,
    gradientTransform: "translate(487.17 50.71) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31d7d6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#30d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25bbbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-2",
    x1: 192.65,
    y1: 636.3,
    x2: 581.25,
    y2: 247.7,
    gradientTransform: "translate(496.88 27.27) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-3",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(506.59 3.82) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-4",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(516.3 -19.63) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-5",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(526.02 -43.07) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-6",
    x1: 159.49,
    y1: 603.14,
    x2: 548.09,
    y2: 214.54,
    gradientTransform: "translate(463.72 41) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-7",
    x1: 176.07,
    y1: 619.72,
    x2: 564.67,
    y2: 231.12,
    gradientTransform: "translate(473.43 17.56) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-8",
    x1: 192.65,
    y1: 636.3,
    x2: 581.25,
    y2: 247.7,
    gradientTransform: "translate(483.15 -5.89) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-9",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(492.86 -29.34) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-10",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(502.57 -52.78) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-11",
    x1: 142.91,
    y1: 586.56,
    x2: 531.51,
    y2: 197.96,
    gradientTransform: "translate(440.28 31.29) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-12",
    x1: 159.49,
    y1: 603.14,
    x2: 548.09,
    y2: 214.54,
    gradientTransform: "translate(449.99 7.84) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-13",
    x1: 176.07,
    y1: 619.72,
    x2: 564.67,
    y2: 231.12,
    gradientTransform: "translate(459.7 -15.6) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-14",
    x1: 192.65,
    y1: 636.3,
    x2: 581.25,
    y2: 247.7,
    gradientTransform: "translate(469.41 -39.05) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-15",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(479.12 -62.5) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-16",
    x1: 126.33,
    y1: 569.98,
    x2: 514.94,
    y2: 181.38,
    gradientTransform: "translate(416.83 21.58) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-17",
    x1: 142.91,
    y1: 586.56,
    x2: 531.51,
    y2: 197.96,
    gradientTransform: "translate(426.54 -1.87) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-18",
    x1: 159.49,
    y1: 603.14,
    x2: 548.09,
    y2: 214.54,
    gradientTransform: "translate(436.25 -25.31) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-19",
    x1: 176.07,
    y1: 619.72,
    x2: 564.67,
    y2: 231.12,
    gradientTransform: "translate(445.97 -48.76) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-20",
    x1: 192.65,
    y1: 636.3,
    x2: 581.25,
    y2: 247.7,
    gradientTransform: "translate(455.68 -72.21) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-21",
    x1: 109.75,
    y1: 553.4,
    x2: 498.36,
    y2: 164.8,
    gradientTransform: "translate(393.38 11.87) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-22",
    x1: 126.33,
    y1: 569.98,
    x2: 514.94,
    y2: 181.38,
    gradientTransform: "translate(403.1 -11.58) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-23",
    x1: 142.91,
    y1: 586.56,
    x2: 531.51,
    y2: 197.96,
    gradientTransform: "translate(412.81 -35.03) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-24",
    x1: 159.49,
    y1: 603.14,
    x2: 548.09,
    y2: 214.54,
    gradientTransform: "translate(422.52 -58.47) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-25",
    x1: 176.07,
    y1: 619.72,
    x2: 564.67,
    y2: 231.12,
    gradientTransform: "translate(432.23 -81.92) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-26",
    x1: 93.17,
    y1: 536.83,
    x2: 481.78,
    y2: 148.22,
    gradientTransform: "translate(369.94 2.15) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-27",
    x1: 109.75,
    y1: 553.4,
    x2: 498.36,
    y2: 164.8,
    gradientTransform: "translate(379.65 -21.29) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-28",
    x1: 126.33,
    y1: 569.98,
    x2: 514.94,
    y2: 181.38,
    gradientTransform: "translate(389.36 -44.74) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-29",
    x1: 142.91,
    y1: 586.56,
    x2: 531.51,
    y2: 197.96,
    gradientTransform: "translate(399.07 -68.18) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-30",
    x1: 159.49,
    y1: 603.14,
    x2: 548.09,
    y2: 214.54,
    gradientTransform: "translate(408.78 -91.63) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-31",
    x1: 76.6,
    y1: 520.25,
    x2: 465.2,
    y2: 131.64,
    gradientTransform: "translate(346.49 -7.56) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-32",
    x1: 93.17,
    y1: 536.83,
    x2: 481.78,
    y2: 148.22,
    gradientTransform: "translate(356.2 -31) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-33",
    x1: 109.75,
    y1: 553.4,
    x2: 498.36,
    y2: 164.8,
    gradientTransform: "translate(365.92 -54.45) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-34",
    x1: 126.33,
    y1: 569.98,
    x2: 514.94,
    y2: 181.38,
    gradientTransform: "translate(375.63 -77.9) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-35",
    x1: 142.91,
    y1: 586.56,
    x2: 531.51,
    y2: 197.96,
    gradientTransform: "translate(385.34 -101.34) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-36",
    x1: 60.02,
    y1: 503.67,
    x2: 448.62,
    y2: 115.06,
    gradientTransform: "translate(323.05 -17.27) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-37",
    x1: 76.6,
    y1: 520.25,
    x2: 465.2,
    y2: 131.64,
    gradientTransform: "translate(332.76 -40.72) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-38",
    x1: 93.17,
    y1: 536.83,
    x2: 481.78,
    y2: 148.22,
    gradientTransform: "translate(342.47 -64.16) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-39",
    x1: 109.75,
    y1: 553.4,
    x2: 498.36,
    y2: 164.8,
    gradientTransform: "translate(352.18 -87.61) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-40",
    x1: 126.33,
    y1: 569.98,
    x2: 514.94,
    y2: 181.38,
    gradientTransform: "translate(361.89 -111.05) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-41",
    x1: 43.44,
    y1: 487.09,
    x2: 432.04,
    y2: 98.49,
    gradientTransform: "translate(299.6 -26.98) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-42",
    x1: 60.02,
    y1: 503.67,
    x2: 448.62,
    y2: 115.06,
    gradientTransform: "translate(309.31 -50.43) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-43",
    x1: 76.6,
    y1: 520.25,
    x2: 465.2,
    y2: 131.64,
    gradientTransform: "translate(319.02 -73.87) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-44",
    x1: 93.17,
    y1: 536.83,
    x2: 481.78,
    y2: 148.22,
    gradientTransform: "translate(328.73 -97.32) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-45",
    x1: 109.75,
    y1: 553.4,
    x2: 498.36,
    y2: 164.8,
    gradientTransform: "translate(338.45 -120.77) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-46",
    x1: 26.86,
    y1: 470.51,
    x2: 415.46,
    y2: 81.91,
    gradientTransform: "translate(276.15 -36.69) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-47",
    x1: 43.44,
    y1: 487.09,
    x2: 432.04,
    y2: 98.49,
    gradientTransform: "translate(285.86 -60.14) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-48",
    x1: 60.02,
    y1: 503.67,
    x2: 448.62,
    y2: 115.06,
    gradientTransform: "translate(295.58 -83.58) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-49",
    x1: 76.6,
    y1: 520.25,
    x2: 465.2,
    y2: 131.64,
    gradientTransform: "translate(305.29 -107.03) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-50",
    x1: 93.17,
    y1: 536.83,
    x2: 481.78,
    y2: 148.22,
    gradientTransform: "translate(315 -130.48) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-51",
    x1: 10.28,
    y1: 453.93,
    x2: 398.88,
    y2: 65.33,
    gradientTransform: "translate(321.38 119.39) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-52",
    x1: 26.86,
    y1: 470.51,
    x2: 415.46,
    y2: 81.91,
    gradientTransform: "translate(331.09 95.94) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-53",
    x1: 43.44,
    y1: 487.09,
    x2: 432.04,
    y2: 98.49,
    gradientTransform: "translate(340.8 72.49) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-54",
    x1: 60.02,
    y1: 503.67,
    x2: 448.62,
    y2: 115.06,
    gradientTransform: "translate(350.51 49.05) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-55",
    x1: 76.6,
    y1: 520.25,
    x2: 465.2,
    y2: 131.64,
    gradientTransform: "translate(360.23 25.6) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-56",
    x1: -6.3,
    y1: 437.35,
    x2: 382.3,
    y2: 48.75,
    gradientTransform: "translate(297.93 109.67) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-57",
    x1: 10.28,
    y1: 453.93,
    x2: 398.88,
    y2: 65.33,
    gradientTransform: "translate(307.64 86.23) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-58",
    x1: 26.86,
    y1: 470.51,
    x2: 415.46,
    y2: 81.91,
    gradientTransform: "translate(317.36 62.78) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-59",
    x1: 43.44,
    y1: 487.09,
    x2: 432.04,
    y2: 98.49,
    gradientTransform: "translate(327.07 39.33) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-60",
    x1: 60.02,
    y1: 503.67,
    x2: 448.62,
    y2: 115.06,
    gradientTransform: "translate(336.78 15.89) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-61",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(274.49 99.96) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-62",
    x1: -6.3,
    y1: 437.35,
    x2: 382.3,
    y2: 48.75,
    gradientTransform: "translate(284.2 76.52) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-63",
    x1: 10.28,
    y1: 453.93,
    x2: 398.88,
    y2: 65.33,
    gradientTransform: "translate(293.91 53.07) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-64",
    x1: 26.86,
    y1: 470.51,
    x2: 415.46,
    y2: 81.91,
    gradientTransform: "translate(303.62 29.62) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-65",
    x1: 43.44,
    y1: 487.09,
    x2: 432.04,
    y2: 98.49,
    gradientTransform: "translate(313.33 6.18) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-66",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(251.04 90.25) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-67",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(260.75 66.8) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-68",
    x1: -6.3,
    y1: 437.35,
    x2: 382.3,
    y2: 48.75,
    gradientTransform: "translate(270.46 43.36) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-69",
    x1: 10.28,
    y1: 453.93,
    x2: 398.88,
    y2: 65.33,
    gradientTransform: "translate(280.18 19.91) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-70",
    x1: 26.86,
    y1: 470.51,
    x2: 415.46,
    y2: 81.91,
    gradientTransform: "translate(289.89 -3.53) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-71",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(227.59 80.54) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-72",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(237.31 57.09) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-73",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(247.02 33.65) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-74",
    x1: -6.3,
    y1: 437.35,
    x2: 382.3,
    y2: 48.75,
    gradientTransform: "translate(256.73 10.2) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-75",
    x1: 10.28,
    y1: 453.93,
    x2: 398.88,
    y2: 65.33,
    gradientTransform: "translate(266.44 -13.25) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-76",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(213.86 47.38) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-77",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(223.57 23.93) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-78",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(233.28 0.49) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-79",
    x1: -6.3,
    y1: 437.35,
    x2: 382.3,
    y2: 48.75,
    gradientTransform: "translate(243 -22.96) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-80",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(200.13 14.22) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-81",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(209.84 -9.22) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-82",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(219.55 -32.67) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-83",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(186.39 -18.94) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-84",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(196.1 -42.38) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-85",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(172.66 -52.09) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-86",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(471.08 -175.7) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-87",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(461.37 -152.26) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-88",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(451.65 -128.81) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-89",
    x1: 192.65,
    y1: 636.3,
    x2: 581.25,
    y2: 247.7,
    gradientTransform: "translate(441.94 -105.36) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-90",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(484.81 -142.55) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-91",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(475.1 -119.1) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-92",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(465.39 -95.65) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-93",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(498.55 -109.39) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-94",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(488.83 -85.94) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-95",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(512.28 -76.23) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-96",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(416.14 -308.33) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-97",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(406.43 -284.89) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-98",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(396.72 -261.44) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-99",
    x1: 192.65,
    y1: 636.3,
    x2: 581.25,
    y2: 247.7,
    gradientTransform: "translate(387 -238) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-100",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(429.87 -275.18) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-101",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(420.16 -251.73) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-102",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(410.45 -228.28) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-103",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(443.61 -242.02) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-104",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(433.9 -218.57) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-105",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(457.34 -208.86) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-106",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(158.92 -85.25) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-107",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(168.63 -108.7) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-108",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(178.35 -132.14) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-109",
    x1: -6.3,
    y1: 437.35,
    x2: 382.3,
    y2: 48.75,
    gradientTransform: "translate(188.06 -155.59) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-110",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(145.19 -118.41) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-111",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(154.9 -141.86) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-112",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(164.61 -165.3) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-113",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(131.45 -151.57) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-114",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(141.17 -175.01) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-115",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(117.72 -184.72) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-116",
    x1: 176.07,
    y1: 619.72,
    x2: 564.67,
    y2: 231.12,
    gradientTransform: "translate(363.56 -247.71) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-117",
    x1: 192.65,
    y1: 636.3,
    x2: 581.25,
    y2: 247.7,
    gradientTransform: "translate(373.27 -271.15) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-118",
    x1: 209.23,
    y1: 652.88,
    x2: 597.83,
    y2: 264.28,
    gradientTransform: "translate(382.98 -294.6) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-119",
    x1: 225.81,
    y1: 669.46,
    x2: 614.41,
    y2: 280.85,
    gradientTransform: "translate(392.69 -318.05) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-120",
    x1: 242.38,
    y1: 686.04,
    x2: 630.99,
    y2: 297.43,
    gradientTransform: "translate(402.41 -341.49) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-121",
    x1: 10.28,
    y1: 453.93,
    x2: 398.88,
    y2: 65.33,
    gradientTransform: "translate(197.77 -179.04) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-122",
    x1: -6.3,
    y1: 437.35,
    x2: 382.3,
    y2: 48.75,
    gradientTransform: "translate(174.32 -188.75) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-123",
    x1: -22.88,
    y1: 420.77,
    x2: 365.72,
    y2: 32.17,
    gradientTransform: "translate(150.88 -198.46) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-124",
    x1: -39.46,
    y1: 404.19,
    x2: 349.15,
    y2: 15.59,
    gradientTransform: "translate(127.43 -208.17) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23-125",
    x1: -56.04,
    y1: 387.62,
    x2: 332.57,
    y2: -0.99,
    gradientTransform: "translate(103.98 -217.88) rotate(45)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.65,
    y: 601.7,
    width: 23.45,
    height: 23.45,
    transform: "translate(-380.34 308.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 203.8,
    y: 601.7,
    width: 23.45,
    height: 23.45,
    transform: "translate(-370.63 332.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 236.96,
    y: 601.7,
    width: 23.45,
    height: 23.45,
    transform: "translate(-360.92 355.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 270.12,
    y: 601.7,
    width: 23.45,
    height: 23.45,
    transform: "translate(-351.2 378.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 303.28,
    y: 601.7,
    width: 23.45,
    height: 23.45,
    transform: "translate(-341.49 402.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 170.65,
    y: 568.54,
    width: 23.45,
    height: 23.45,
    transform: "translate(-356.89 298.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 203.8,
    y: 568.54,
    width: 23.45,
    height: 23.45,
    transform: "translate(-347.18 322.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 236.96,
    y: 568.54,
    width: 23.45,
    height: 23.45,
    transform: "translate(-337.47 345.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 270.12,
    y: 568.54,
    width: 23.45,
    height: 23.45,
    transform: "translate(-327.76 369.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 303.28,
    y: 568.54,
    width: 23.45,
    height: 23.45,
    transform: "translate(-318.05 392.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 170.65,
    y: 535.38,
    width: 23.45,
    height: 23.45,
    transform: "translate(-333.45 289.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 203.8,
    y: 535.38,
    width: 23.45,
    height: 23.45,
    transform: "translate(-323.74 312.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 236.96,
    y: 535.38,
    width: 23.45,
    height: 23.45,
    transform: "translate(-314.02 336.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 270.12,
    y: 535.38,
    width: 23.45,
    height: 23.45,
    transform: "translate(-304.31 359.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 303.28,
    y: 535.38,
    width: 23.45,
    height: 23.45,
    transform: "translate(-294.6 382.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 170.65,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-310 279.49) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 203.8,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-300.29 302.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 236.96,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-290.58 326.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 270.12,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-280.87 349.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 303.28,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-271.15 373.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 170.65,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-286.56 269.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 203.8,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-276.84 293.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 236.96,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-267.13 316.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 270.12,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-257.42 340.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 303.28,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-247.71 363.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 170.65,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-263.11 260.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 203.8,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-253.4 283.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 236.96,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-243.69 306.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 270.12,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-233.97 330.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 303.28,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-224.26 353.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 170.65,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-239.66 250.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 203.8,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-229.95 273.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 236.96,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-220.24 297.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 270.12,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-210.53 320.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 303.28,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-200.82 344.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 170.65,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-216.22 240.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 203.8,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-206.5 264.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 236.96,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-196.79 287.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 270.12,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-187.08 310.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 303.28,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-177.37 334.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 170.65,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-192.77 230.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 203.8,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-183.06 254.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 236.96,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-173.35 277.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 270.12,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-163.64 301.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 303.28,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-153.92 324.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 170.65,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-169.32 221.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 203.8,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-159.61 244.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 236.96,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-149.9 268.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 270.12,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-140.19 291.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 303.28,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-130.48 315) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 4.86,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-311.67 142.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 38.01,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-301.96 166.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 71.17,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-292.24 189.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 104.33,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-282.53 213.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 137.49,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-272.82 236.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 4.86,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-288.22 133.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 38.01,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-278.51 156.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 71.17,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-268.8 180.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 104.33,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-259.09 203.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 137.49,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-249.37 226.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 4.86,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-264.78 123.41) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 38.01,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-255.06 146.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 71.17,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-245.35 170.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 104.33,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-235.64 193.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 137.49,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-225.93 217.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 4.86,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-241.33 113.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 38.01,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-231.62 137.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 71.17,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-221.91 160.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 104.33,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-212.19 184.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 137.49,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-202.48 207.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 4.86,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-217.88 103.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 38.01,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-208.17 127.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 71.17,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-198.46 150.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 104.33,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-188.75 174.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 137.49,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-179.04 197.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 38.01,
    y: 270.12,
    width: 23.45,
    height: 23.45,
    transform: "translate(-184.72 117.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 71.17,
    y: 270.12,
    width: 23.45,
    height: 23.45,
    transform: "translate(-175.01 141.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 104.33,
    y: 270.12,
    width: 23.45,
    height: 23.45,
    transform: "translate(-165.3 164.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 137.49,
    y: 270.12,
    width: 23.45,
    height: 23.45,
    transform: "translate(-155.59 188.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 71.17,
    y: 236.96,
    width: 23.45,
    height: 23.45,
    transform: "translate(-151.57 131.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 104.33,
    y: 236.96,
    width: 23.45,
    height: 23.45,
    transform: "translate(-141.86 154.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 137.49,
    y: 236.96,
    width: 23.45,
    height: 23.45,
    transform: "translate(-132.14 178.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 104.33,
    y: 203.8,
    width: 23.45,
    height: 23.45,
    transform: "translate(-118.41 145.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 137.49,
    y: 203.8,
    width: 23.45,
    height: 23.45,
    transform: "translate(-108.7 168.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 137.49,
    y: 170.65,
    width: 23.45,
    height: 23.45,
    transform: "translate(-85.25 158.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 435.91,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-208.86 457.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 402.75,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-218.57 433.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 369.59,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-228.28 410.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 336.43,
    y: 469.07,
    width: 23.45,
    height: 23.45,
    transform: "translate(-238 387) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 402.75,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-242.02 443.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 369.59,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-251.73 420.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 336.43,
    y: 502.22,
    width: 23.45,
    height: 23.45,
    transform: "translate(-261.44 396.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 369.59,
    y: 535.38,
    width: 23.45,
    height: 23.45,
    transform: "translate(-275.18 429.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 336.43,
    y: 535.38,
    width: 23.45,
    height: 23.45,
    transform: "translate(-284.89 406.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 336.43,
    y: 568.54,
    width: 23.45,
    height: 23.45,
    transform: "translate(-308.33 416.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 568.54,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-76.23 512.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 535.38,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-85.94 488.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 502.22,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-95.65 465.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 469.07,
    y: 336.43,
    width: 23.45,
    height: 23.45,
    transform: "translate(-105.36 441.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 535.38,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-109.39 498.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 502.22,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-119.1 475.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 469.07,
    y: 369.59,
    width: 23.45,
    height: 23.45,
    transform: "translate(-128.81 451.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 502.22,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-142.55 484.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 469.07,
    y: 402.75,
    width: 23.45,
    height: 23.45,
    transform: "translate(-152.26 461.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 469.07,
    y: 435.91,
    width: 23.45,
    height: 23.45,
    transform: "translate(-175.7 471.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 170.65,
    y: 137.49,
    width: 23.45,
    height: 23.45,
    transform: "translate(-52.09 172.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 203.8,
    y: 137.49,
    width: 23.45,
    height: 23.45,
    transform: "translate(-42.38 196.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 236.96,
    y: 137.49,
    width: 23.45,
    height: 23.45,
    transform: "translate(-32.67 219.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 270.12,
    y: 137.49,
    width: 23.45,
    height: 23.45,
    transform: "translate(-22.96 243) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 203.8,
    y: 104.33,
    width: 23.45,
    height: 23.45,
    transform: "translate(-18.94 186.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 236.96,
    y: 104.33,
    width: 23.45,
    height: 23.45,
    transform: "translate(-9.22 209.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 270.12,
    y: 104.33,
    width: 23.45,
    height: 23.45,
    transform: "translate(0.49 233.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 236.96,
    y: 71.17,
    width: 23.45,
    height: 23.45,
    transform: "translate(14.22 200.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 270.12,
    y: 71.17,
    width: 23.45,
    height: 23.45,
    transform: "translate(23.93 223.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 270.12,
    y: 38.01,
    width: 23.45,
    height: 23.45,
    transform: "translate(47.38 213.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 469.07,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-81.92 432.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 502.22,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-72.21 455.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 535.38,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-62.5 479.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 568.54,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-52.78 502.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 601.7,
    y: 303.28,
    width: 23.45,
    height: 23.45,
    transform: "translate(-43.07 526.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 303.28,
    y: 137.49,
    width: 23.45,
    height: 23.45,
    transform: "translate(-13.25 266.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 303.28,
    y: 104.33,
    width: 23.45,
    height: 23.45,
    transform: "translate(10.2 256.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 303.28,
    y: 71.17,
    width: 23.45,
    height: 23.45,
    transform: "translate(33.65 247.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 303.28,
    y: 38.01,
    width: 23.45,
    height: 23.45,
    transform: "translate(57.09 237.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 303.28,
    y: 4.86,
    width: 23.45,
    height: 23.45,
    transform: "translate(80.54 227.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M696,308.46l36.08-55.23q-14.89-4.9-22.42-15.7t-7.55-25.68a50,50,0,0,1,3.47-18.95,37.9,37.9,0,0,1,10.19-14.47,48.31,48.31,0,0,1,16.82-9.28,74.54,74.54,0,0,1,23.54-3.36h58.08V308.46H783.41V256.69H759.76l-31.59,51.77Zm87.44-76.23V191.47h-21.2q-16.31,0-22.83,5.3t-6.52,15.08q0,9.78,6.52,15.08t22.83,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M849.07,308.46V165.79h55a85.32,85.32,0,0,1,25.27,3.36,51.16,51.16,0,0,1,17.94,9.38,35.83,35.83,0,0,1,10.5,14.77,58.67,58.67,0,0,1,0,39.14,35.76,35.76,0,0,1-10.5,14.77,51,51,0,0,1-17.94,9.38A85.32,85.32,0,0,1,904.1,260H879.85v48.51Zm30.78-74.19h21.2q16.29,0,22.82-5.6t6.52-15.8q0-10.19-6.52-15.8t-22.82-5.6h-21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M987.52,308.46V165.79h31.59l42.39,78.47,42-78.47h30.77V308.46h-30.77V218l-33.43,62h-18.34l-33.43-62v90.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1169.15,308.46V165.79h30.78v94.36l62.77-94.36h28.74V308.46h-30.77V214.09l-62.78,94.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1316.1,308.46l53-142.67h30.78l52.79,142.67h-32.61l-11.21-30h-51.77l-11.21,30ZM1366,254h33.83L1383,203.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1585.86,335V308.46H1477.64V165.79h30.78v117h56.66v-117h30.77v117h17.33V335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M696,402.59l8.45-12.94a9.73,9.73,0,0,1-5.35-3.28,8.59,8.59,0,0,1-1.78-5.35,9,9,0,0,1,.75-3.68,8,8,0,0,1,2.2-2.92,10.47,10.47,0,0,1,3.63-1.94,16.53,16.53,0,0,1,5.08-.71h10.79v30.82H715.6V390.17h-7.13l-7.84,12.42Zm19.63-15.94V375.38h-6.21c-2.84,0-4.88.53-6.11,1.57a5.4,5.4,0,0,0,0,8.14q1.85,1.56,6.11,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M727.3,402.59V379.26h3.88V389h3.08l8.71-9.77h4.58l-10.12,11.18L748,402.59h-4.93l-8.8-10.21h-3.08v10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M756.36,411.81a4.32,4.32,0,0,1-.66-.11v-3.52a6,6,0,0,0,.66.11l.66,0a2.91,2.91,0,0,0,1.15-.22,2.65,2.65,0,0,0,.94-.84,8.42,8.42,0,0,0,.95-1.74c.32-.74.7-1.72,1.14-2.92l-9.9-23.33h4.31l7.57,18.93,6.87-18.93h4.14l-8.81,23.33c-.61,1.64-1.2,3.05-1.76,4.22a12.75,12.75,0,0,1-1.78,2.88,5.76,5.76,0,0,1-2.09,1.63,6.65,6.65,0,0,1-2.73.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M785.57,402.59v-19.9h-8v-3.43h19.81v3.43h-8v19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M806.8,402.3a8.85,8.85,0,0,1-3.34-2.2,10.35,10.35,0,0,1-2.22-3.72,15.17,15.17,0,0,1-.82-5.24v-.88a12.93,12.93,0,0,1,.88-5,10.68,10.68,0,0,1,2.33-3.57,9.83,9.83,0,0,1,3.37-2.16,11.85,11.85,0,0,1,7.7-.15,9.15,9.15,0,0,1,2.87,1.58,8.89,8.89,0,0,1,2,2.38,10.91,10.91,0,0,1,1.12,2.95h-4a8,8,0,0,0-2-2.82,5.44,5.44,0,0,0-3.76-1.14,6.69,6.69,0,0,0-2.47.46,5.93,5.93,0,0,0-2.11,1.41,6.84,6.84,0,0,0-1.48,2.44,10.42,10.42,0,0,0-.55,3.61v.88a11.82,11.82,0,0,0,.55,3.85,7.16,7.16,0,0,0,1.48,2.6,5.55,5.55,0,0,0,2.11,1.45,6.69,6.69,0,0,0,2.47.47,6.13,6.13,0,0,0,3.63-1.06,5.64,5.64,0,0,0,2.09-2.91h4a9.76,9.76,0,0,1-1.28,3.11,9.05,9.05,0,0,1-2.13,2.35,9.53,9.53,0,0,1-2.84,1.5A10.86,10.86,0,0,1,811,403,11.94,11.94,0,0,1,806.8,402.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M826.18,402.59V379.26h3.88V389h3.08l8.71-9.77h4.58l-10.12,11.18,10.56,12.15h-4.93l-8.8-10.21h-3.08v10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M851.7,402.59V379.26h3.88v17.6l12.06-17.6h3.87v23.33h-3.87V385l-12.06,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M878.64,402.59V379.26h3.88v17.6l12.06-17.6h3.87v23.33h-3.87V385l-12.06,17.61Zm4.89-27.67a5.51,5.51,0,0,1-1.59-4.25h3.79a3.18,3.18,0,0,0,.7,2.25,2.78,2.78,0,0,0,2.12.75,2.91,2.91,0,0,0,2.18-.75,3.14,3.14,0,0,0,.72-2.25h3.7a5.51,5.51,0,0,1-1.59,4.25q-1.57,1.49-5,1.48C886.26,376.4,884.58,375.91,883.53,374.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M916.49,411.39V379.26h3.61v4.4a8.64,8.64,0,0,1,3.33-3.59,9.63,9.63,0,0,1,5-1.25,9.09,9.09,0,0,1,7,2.88c1.76,1.92,2.64,4.78,2.64,8.56v.88a17.41,17.41,0,0,1-.7,5.2,10.33,10.33,0,0,1-2,3.71,8.13,8.13,0,0,1-3.06,2.23,10.06,10.06,0,0,1-3.94.75,8.86,8.86,0,0,1-5-1.32,8.72,8.72,0,0,1-3-3.3v13ZM930.14,399a5.93,5.93,0,0,0,2.13-1.6,7.4,7.4,0,0,0,1.41-2.64,12,12,0,0,0,.51-3.66v-.88a10.41,10.41,0,0,0-.51-3.41,7.22,7.22,0,0,0-1.41-2.51,5.82,5.82,0,0,0-2.13-1.56,6.66,6.66,0,0,0-2.64-.53,8,8,0,0,0-2.91.51,6.32,6.32,0,0,0-3.69,3.54,6.49,6.49,0,0,0-.53,2.64v3.52a7.61,7.61,0,0,0,.53,2.91,6.42,6.42,0,0,0,1.45,2.24,6.69,6.69,0,0,0,2.24,1.46,7.81,7.81,0,0,0,2.91.52A6.34,6.34,0,0,0,930.14,399Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M949.55,402.32a9.67,9.67,0,0,1-3.57-2.18,10.51,10.51,0,0,1-2.46-3.72,13.69,13.69,0,0,1-.93-5.28v-.88a13.32,13.32,0,0,1,.88-5,10.36,10.36,0,0,1,2.36-3.56,9.42,9.42,0,0,1,3.43-2.14,12.09,12.09,0,0,1,4.12-.7q5.19,0,8,2.79t2.79,8v2.47H946.47a8.17,8.17,0,0,0,.66,3.45,6.4,6.4,0,0,0,1.71,2.31,6.63,6.63,0,0,0,2.36,1.28,9.05,9.05,0,0,0,2.62.4,7.88,7.88,0,0,0,4.07-.88,5,5,0,0,0,2-2.43h3.79a7.91,7.91,0,0,1-1.25,2.95,8.18,8.18,0,0,1-2.21,2.14,10,10,0,0,1-3,1.3,13.56,13.56,0,0,1-3.49.44A12.88,12.88,0,0,1,949.55,402.32Zm11-13.42a8,8,0,0,0-.6-3.06,5.43,5.43,0,0,0-1.47-2,6,6,0,0,0-2.18-1.12,10,10,0,0,0-2.66-.35,9.42,9.42,0,0,0-2.65.37,6.36,6.36,0,0,0-2.26,1.19,6.3,6.3,0,0,0-1.61,2.05,6.52,6.52,0,0,0-.61,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M975.05,402.3a8.78,8.78,0,0,1-3.34-2.2,10.51,10.51,0,0,1-2.23-3.72,15.42,15.42,0,0,1-.81-5.24v-.88a12.93,12.93,0,0,1,.88-5,10.53,10.53,0,0,1,2.33-3.57,9.73,9.73,0,0,1,3.37-2.16,11.22,11.22,0,0,1,4-.72,11.35,11.35,0,0,1,3.72.57,9,9,0,0,1,2.86,1.58,8.53,8.53,0,0,1,2,2.38,10.61,10.61,0,0,1,1.13,2.95h-4a7.88,7.88,0,0,0-2-2.82,5.47,5.47,0,0,0-3.77-1.14,6.67,6.67,0,0,0-2.46.46,6.06,6.06,0,0,0-2.12,1.41,7,7,0,0,0-1.47,2.44,10.42,10.42,0,0,0-.55,3.61v.88a11.82,11.82,0,0,0,.55,3.85,7.29,7.29,0,0,0,1.47,2.6,5.67,5.67,0,0,0,2.12,1.45,6.68,6.68,0,0,0,2.46.47,6.09,6.09,0,0,0,3.63-1.06,5.59,5.59,0,0,0,2.09-2.91h4a10,10,0,0,1-1.28,3.11,9.23,9.23,0,0,1-2.13,2.35,9.53,9.53,0,0,1-2.84,1.5,10.92,10.92,0,0,1-3.44.53A11.92,11.92,0,0,1,975.05,402.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M994.43,402.59V379.26h19.37v23.33h-3.88v-19.9H998.3v19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1023.61,411.81a4.32,4.32,0,0,1-.66-.11v-3.52a6,6,0,0,0,.66.11l.66,0a2.83,2.83,0,0,0,1.14-.22,2.59,2.59,0,0,0,.95-.84,8.92,8.92,0,0,0,1-1.74c.32-.74.7-1.72,1.14-2.92l-9.9-23.33h4.31l7.57,18.93,6.87-18.93h4.14l-8.81,23.33c-.61,1.64-1.2,3.05-1.76,4.22a12.75,12.75,0,0,1-1.78,2.88,5.76,5.76,0,0,1-2.09,1.63,6.65,6.65,0,0,1-2.73.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1051.71,402.15a9.76,9.76,0,0,1-3.5-2.58,12.48,12.48,0,0,1-2.33-4.16,17,17,0,0,1-.86-5.59v-.88a39.33,39.33,0,0,1,.57-7.06,14.74,14.74,0,0,1,2-5.28,9.9,9.9,0,0,1,3.65-3.42,13.35,13.35,0,0,1,5.7-1.41c.94,0,1.81-.09,2.6-.11s1.54-.05,2.25-.13,1.34-.17,1.93-.28a5.28,5.28,0,0,0,1.59-.58v3.75a6.29,6.29,0,0,1-1,.33,13.88,13.88,0,0,1-1.59.26c-.63.07-1.37.14-2.22.2s-1.82.1-2.91.13a14.19,14.19,0,0,0-3.72.53,6.8,6.8,0,0,0-2.73,1.54,7.15,7.15,0,0,0-1.75,2.75,14.86,14.86,0,0,0-.82,4.16,8,8,0,0,1,1.36-2.11,8.78,8.78,0,0,1,1.9-1.59,8.56,8.56,0,0,1,2.35-1,10.31,10.31,0,0,1,2.75-.35,10.47,10.47,0,0,1,4.1.77,9.3,9.3,0,0,1,3.19,2.18,9.93,9.93,0,0,1,2.09,3.45,13.33,13.33,0,0,1,.75,4.6v.88a13.64,13.64,0,0,1-.84,4.89,11.36,11.36,0,0,1-2.29,3.76,9.87,9.87,0,0,1-3.48,2.4,11.35,11.35,0,0,1-4.4.84A10.82,10.82,0,0,1,1051.71,402.15Zm9.38-4.76q2-2.11,2-6.25v-.88a8.54,8.54,0,0,0-.53-3.08,7.43,7.43,0,0,0-1.45-2.36,6.17,6.17,0,0,0-2.23-1.51,7.87,7.87,0,0,0-5.68,0,6.21,6.21,0,0,0-2.22,1.51,7.25,7.25,0,0,0-1.45,2.36,8.54,8.54,0,0,0-.53,3.08v.88a10.41,10.41,0,0,0,.55,3.5,7.76,7.76,0,0,0,1.52,2.64,6.6,6.6,0,0,0,5,2.23A6.66,6.66,0,0,0,1061.09,397.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1070.8,403a3.25,3.25,0,0,1-.66-.11V399a.57.57,0,0,0,.26.05h.4a2.54,2.54,0,0,0,1.72-.62,4.43,4.43,0,0,0,1.14-2.16,23.36,23.36,0,0,0,.66-4.18q.23-2.64.22-6.69v-6.16h16.73v23.33h-3.88v-19.9h-9v3.61a60.31,60.31,0,0,1-.44,8.1,18.83,18.83,0,0,1-1.3,5.13,5.72,5.72,0,0,1-2.17,2.7,5.8,5.8,0,0,1-3,.8Q1071.1,403,1070.8,403Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1098.37,402.59V379.26h3.88v17.6l12.06-17.6h3.87v23.33h-3.87V385l-12.06,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1125.31,402.59V379.26h3.88V389h3.08l8.71-9.77h4.58l-10.12,11.18L1146,402.59h-4.93l-8.8-10.21h-3.08v10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1153.42,402.48a7.3,7.3,0,0,1-2.51-1.52,6.52,6.52,0,0,1-1.54-2.29,7.81,7.81,0,0,1-.53-2.91c0-2.31.68-4,2.05-5a9.6,9.6,0,0,1,5.88-1.54h7.57v-1.59c0-2-.45-3.41-1.34-4.16a6.17,6.17,0,0,0-4-1.12,5.67,5.67,0,0,0-3.66,1,3.23,3.23,0,0,0-1.27,2.13h-3.88a6.13,6.13,0,0,1,.77-2.62,6.81,6.81,0,0,1,1.85-2.09,9.06,9.06,0,0,1,2.8-1.39,12.35,12.35,0,0,1,3.61-.5,14,14,0,0,1,3.74.46,7.31,7.31,0,0,1,2.84,1.47,6.78,6.78,0,0,1,1.8,2.6,10.16,10.16,0,0,1,.64,3.83v9.46c0,1.24,0,2.32,0,3.24a24,24,0,0,0,.2,2.71H1165q-.13-1-.18-1.92c0-.6,0-1.28,0-2a6.52,6.52,0,0,1-1.21,1.71,8.5,8.5,0,0,1-1.78,1.39,9.64,9.64,0,0,1-2.29.94,10.64,10.64,0,0,1-6.12-.19Zm6.8-3.35a6.48,6.48,0,0,0,2.14-1.1,5.11,5.11,0,0,0,1.45-1.8,5.54,5.54,0,0,0,.53-2.45V392.2h-6.91a5.79,5.79,0,0,0-3.39.86,3.06,3.06,0,0,0-1.24,2.7,3.46,3.46,0,0,0,1.17,2.69,5.39,5.39,0,0,0,3.68,1.06A8.64,8.64,0,0,0,1160.22,399.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1175.16,402.59V379.26H1179V389h12.06v-9.73H1195v23.33h-3.87V392.42H1179v10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1207.22,402.3a8.78,8.78,0,0,1-3.34-2.2,10.51,10.51,0,0,1-2.23-3.72,15.42,15.42,0,0,1-.81-5.24v-.88a12.93,12.93,0,0,1,.88-5,10.53,10.53,0,0,1,2.33-3.57,9.73,9.73,0,0,1,3.37-2.16,11.22,11.22,0,0,1,4-.72,11.35,11.35,0,0,1,3.72.57A9,9,0,0,1,1218,381a8.53,8.53,0,0,1,2,2.38,10.61,10.61,0,0,1,1.13,2.95h-4a7.88,7.88,0,0,0-1.95-2.82,5.47,5.47,0,0,0-3.77-1.14,6.67,6.67,0,0,0-2.46.46,6,6,0,0,0-2.12,1.41,7,7,0,0,0-1.47,2.44,10.42,10.42,0,0,0-.55,3.61v.88a11.82,11.82,0,0,0,.55,3.85,7.29,7.29,0,0,0,1.47,2.6,5.59,5.59,0,0,0,2.12,1.45,6.68,6.68,0,0,0,2.46.47,6.09,6.09,0,0,0,3.63-1.06,5.59,5.59,0,0,0,2.09-2.91h4a10,10,0,0,1-1.28,3.11,9.23,9.23,0,0,1-2.13,2.35,9.53,9.53,0,0,1-2.84,1.5,10.92,10.92,0,0,1-3.44.53A11.92,11.92,0,0,1,1207.22,402.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1226.6,402.59V379.26h3.88V389h3.08l8.71-9.77h4.58l-10.12,11.18,10.56,12.15h-4.93l-8.8-10.21h-3.08v10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1252.12,402.59V379.26H1256v17.6l12.06-17.6h3.87v23.33h-3.87V385L1256,402.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1279.06,402.59V379.26h3.87v17.6l12.06-17.6h3.88v23.33H1295V385l-12.06,17.61Zm4.89-27.67a5.51,5.51,0,0,1-1.59-4.25h3.79a3.18,3.18,0,0,0,.7,2.25,2.76,2.76,0,0,0,2.11.75,2.9,2.9,0,0,0,2.18-.75,3.09,3.09,0,0,0,.73-2.25h3.7a5.51,5.51,0,0,1-1.59,4.25q-1.59,1.49-5,1.48T1284,374.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1316.91,402.59V379.26h4.14l8.32,14.52,8.32-14.52h3.87v23.33h-3.87V385.64l-6.91,11.88h-3.08l-6.91-11.88v16.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1354.38,402.32a9.55,9.55,0,0,1-3.56-2.18,10.67,10.67,0,0,1-2.47-3.72,13.89,13.89,0,0,1-.92-5.28v-.88a13.12,13.12,0,0,1,.88-5,10.48,10.48,0,0,1,2.35-3.56,9.46,9.46,0,0,1,3.44-2.14,12,12,0,0,1,4.11-.7c3.46,0,6.13.93,8,2.79s2.8,4.53,2.8,8v2.47h-17.7a8.17,8.17,0,0,0,.66,3.45,6.31,6.31,0,0,0,1.72,2.31,6.58,6.58,0,0,0,2.35,1.28,9.1,9.1,0,0,0,2.62.4,7.86,7.86,0,0,0,4.07-.88,4.92,4.92,0,0,0,2-2.43h3.79a8,8,0,0,1-3.46,5.09,10.13,10.13,0,0,1-2.95,1.3,13.7,13.7,0,0,1-3.5.44A12.93,12.93,0,0,1,1354.38,402.32Zm11-13.42a8,8,0,0,0-.59-3.06,5.45,5.45,0,0,0-1.48-2,5.89,5.89,0,0,0-2.17-1.12,10.07,10.07,0,0,0-2.67-.35,9.3,9.3,0,0,0-2.64.37,6.41,6.41,0,0,0-2.27,1.19,6.27,6.27,0,0,0-1.6,2.05,6.52,6.52,0,0,0-.62,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1372.29,408.09v-8.94h2.86a6.57,6.57,0,0,0,.89-2,30.3,30.3,0,0,0,.7-3.22c.21-1.23.36-2.57.46-4s.16-2.94.16-4.47v-6.16h16.28v19.89h3.3v8.94h-3.69v-5.5H1376v5.5Zm17.48-8.94V382.69h-8.63v3.61a50.13,50.13,0,0,1-.5,7.17,21.86,21.86,0,0,1-1.52,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1401.89,402.59V379.26h3.88v17.6l12.06-17.6h3.87v23.33h-3.87V385l-12.06,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1447.8,408.09v-5.5h-19V379.26h3.88v19.89h11.18V379.26h3.87v19.89h3.74v8.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1456.33,402.59V379.26h3.88v17.6l12.06-17.6h3.87v23.33h-3.87V385l-12.06,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1483.27,402.59V379.26h3.87V389h12.06v-9.73h3.88v23.33h-3.88V392.42h-12.06v10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1515.33,402.3a8.89,8.89,0,0,1-3.35-2.2,10.35,10.35,0,0,1-2.22-3.72,15.42,15.42,0,0,1-.81-5.24v-.88a12.93,12.93,0,0,1,.88-5,10.39,10.39,0,0,1,2.33-3.57,9.73,9.73,0,0,1,3.37-2.16,11.18,11.18,0,0,1,4-.72,11.35,11.35,0,0,1,3.72.57,9.1,9.1,0,0,1,2.86,1.58,8.53,8.53,0,0,1,2,2.38,10.59,10.59,0,0,1,1.12,2.95h-4a7.9,7.9,0,0,0-2-2.82,5.42,5.42,0,0,0-3.76-1.14,6.76,6.76,0,0,0-2.47.46,6,6,0,0,0-2.11,1.41,6.82,6.82,0,0,0-1.47,2.44,10.42,10.42,0,0,0-.55,3.61v.88a11.82,11.82,0,0,0,.55,3.85,7.14,7.14,0,0,0,1.47,2.6A5.63,5.63,0,0,0,1517,399a6.77,6.77,0,0,0,2.47.47,6.09,6.09,0,0,0,3.63-1.06,5.64,5.64,0,0,0,2.09-2.91h4a10,10,0,0,1-1.27,3.11,9.09,9.09,0,0,1-2.14,2.35,9.29,9.29,0,0,1-2.84,1.5,10.82,10.82,0,0,1-3.43.53A11.88,11.88,0,0,1,1515.33,402.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1534.71,402.59V379.26h3.87V389h3.08l8.72-9.77H1555l-10.13,11.18,10.57,12.15h-4.93l-8.81-10.21h-3.08v10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1560.23,402.59V379.26h3.87v17.6l12.06-17.6H1580v23.33h-3.88V385l-12.06,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1587.17,402.59V379.26H1591v17.6l12.06-17.6H1607v23.33h-3.87V385L1591,402.59Zm4.88-27.67a5.54,5.54,0,0,1-1.58-4.25h3.78a3.18,3.18,0,0,0,.71,2.25,2.76,2.76,0,0,0,2.11.75,2.91,2.91,0,0,0,2.18-.75,3.14,3.14,0,0,0,.73-2.25h3.69a5.5,5.5,0,0,1-1.58,4.25q-1.59,1.49-5,1.48T1592.05,374.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M697.51,455.41V432.08h3.88v17.6l12.05-17.6h3.88v23.33h-3.88V437.8l-12.05,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M724.45,455.41V432.08h3.87v9.73h12.06v-9.73h3.87v23.33h-3.87V445.24H728.32v10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M762.49,464.21v-8.36q-6.07,0-9.22-3.09T750.12,444v-.88q0-5.46,3.13-8.48t9.24-3v-7.05h3.87v7.05a16.72,16.72,0,0,1,5.35.77,10.28,10.28,0,0,1,3.88,2.26,9.7,9.7,0,0,1,2.35,3.61,13.74,13.74,0,0,1,.79,4.85V444q0,5.67-3.14,8.75t-9.23,3.09v8.36Zm0-29q-4.41,0-6.43,2t-2,6V444q0,4.26,2,6.29t6.43,2Zm3.78,17.17c2.93,0,5.08-.68,6.43-2s2-3.45,2-6.29v-.88q0-4-2-6c-1.35-1.32-3.5-2-6.43-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M790.22,455.12a10,10,0,0,1-3.57-2.2,10.51,10.51,0,0,1-2.46-3.72,13.62,13.62,0,0,1-.93-5.24v-.88a12.46,12.46,0,0,1,.93-5,10.3,10.3,0,0,1,2.46-3.56,10.48,10.48,0,0,1,3.57-2.16,13,13,0,0,1,8.53,0,10.15,10.15,0,0,1,6,5.72,12.46,12.46,0,0,1,.93,5V444a13.62,13.62,0,0,1-.93,5.24,10.51,10.51,0,0,1-2.46,3.72,9.9,9.9,0,0,1-3.57,2.2,12.82,12.82,0,0,1-8.53,0Zm6.91-3.26a6.18,6.18,0,0,0,2.33-1.45,7.59,7.59,0,0,0,1.65-2.57,10.33,10.33,0,0,0,.64-3.88v-.88a9.1,9.1,0,0,0-.64-3.61,7.48,7.48,0,0,0-1.65-2.46,6.08,6.08,0,0,0-2.33-1.41,8.4,8.4,0,0,0-2.64-.44,8.51,8.51,0,0,0-2.65.44,6.08,6.08,0,0,0-2.33,1.41,7.48,7.48,0,0,0-1.65,2.46,9.29,9.29,0,0,0-.64,3.61V444a10.53,10.53,0,0,0,.64,3.88,7.59,7.59,0,0,0,1.65,2.57,6.18,6.18,0,0,0,2.33,1.45,8,8,0,0,0,2.65.47A7.91,7.91,0,0,0,797.13,451.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M811.48,464.21V432.08h3.61v4.4a8.58,8.58,0,0,1,3.33-3.59,9.63,9.63,0,0,1,5-1.25,9.09,9.09,0,0,1,7,2.88c1.76,1.92,2.64,4.78,2.64,8.56V444a17.41,17.41,0,0,1-.7,5.2,10.33,10.33,0,0,1-2,3.71,8.13,8.13,0,0,1-3.06,2.23,10.06,10.06,0,0,1-3.94.75,8.47,8.47,0,0,1-8-4.62v13Zm13.65-12.35a5.93,5.93,0,0,0,2.13-1.6,7.36,7.36,0,0,0,1.41-2.65,11.87,11.87,0,0,0,.51-3.65v-.88a10.41,10.41,0,0,0-.51-3.41,7.22,7.22,0,0,0-1.41-2.51,5.82,5.82,0,0,0-2.13-1.56,6.66,6.66,0,0,0-2.64-.53,8,8,0,0,0-2.91.51,6.41,6.41,0,0,0-2.24,1.4,6.59,6.59,0,0,0-1.45,2.14,6.49,6.49,0,0,0-.53,2.64v3.52a7.61,7.61,0,0,0,.53,2.91,6.42,6.42,0,0,0,1.45,2.24,6.69,6.69,0,0,0,2.24,1.46,7.81,7.81,0,0,0,2.91.52A6.34,6.34,0,0,0,825.13,451.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M839,455.41V432.08h4.14l8.32,14.52,8.32-14.52h3.87v23.33h-3.87v-17l-6.91,11.88h-3.08l-6.91-11.88v17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M874.05,455.3a7.3,7.3,0,0,1-2.51-1.52,6.52,6.52,0,0,1-1.54-2.29,7.81,7.81,0,0,1-.53-2.91q0-3.48,2-5a9.59,9.59,0,0,1,5.87-1.54H885v-1.59c0-2-.45-3.41-1.35-4.16a6.14,6.14,0,0,0-4-1.12,5.65,5.65,0,0,0-3.66.95,3.19,3.19,0,0,0-1.27,2.13h-3.88a6.13,6.13,0,0,1,.77-2.62,6.81,6.81,0,0,1,1.85-2.09,9.06,9.06,0,0,1,2.8-1.39,12.35,12.35,0,0,1,3.61-.5,14,14,0,0,1,3.74.46,7.31,7.31,0,0,1,2.84,1.47,6.7,6.7,0,0,1,1.8,2.6,10.16,10.16,0,0,1,.64,3.83v9.46c0,1.24,0,2.32,0,3.24a24,24,0,0,0,.2,2.71h-3.39q-.13-1-.18-1.92c0-.6,0-1.28,0-2a6.52,6.52,0,0,1-1.21,1.71,8.5,8.5,0,0,1-1.78,1.39,9.64,9.64,0,0,1-2.29.94,10.64,10.64,0,0,1-6.12-.19Zm6.8-3.35a6.48,6.48,0,0,0,2.14-1.1,5.2,5.2,0,0,0,1.45-1.8,5.54,5.54,0,0,0,.53-2.45V445h-6.91a5.79,5.79,0,0,0-3.39.86,3.06,3.06,0,0,0-1.24,2.7,3.47,3.47,0,0,0,1.17,2.69,5.39,5.39,0,0,0,3.68,1.06A8.64,8.64,0,0,0,880.85,452Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M914.72,460.91v-5.5h-19V432.08h3.87V452H910.8V432.08h3.88V452h3.74v8.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M923.25,455.41V432.08h3.88v17.6l12-17.6h3.88v23.33h-3.88V437.8l-12,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M955.81,455.12a10,10,0,0,1-3.57-2.2,10.65,10.65,0,0,1-2.46-3.72,13.62,13.62,0,0,1-.93-5.24v-.88a12.46,12.46,0,0,1,.93-5,10.15,10.15,0,0,1,6-5.72,13,13,0,0,1,8.54,0,10.34,10.34,0,0,1,3.56,2.16,10.45,10.45,0,0,1,2.47,3.56,12.64,12.64,0,0,1,.92,5V444a13.82,13.82,0,0,1-.92,5.24,10.67,10.67,0,0,1-2.47,3.72,9.86,9.86,0,0,1-3.56,2.2,12.85,12.85,0,0,1-8.54,0Zm6.91-3.26a6.1,6.1,0,0,0,2.33-1.45,7.3,7.3,0,0,0,1.65-2.57,10.33,10.33,0,0,0,.64-3.88v-.88a9.1,9.1,0,0,0-.64-3.61,7.19,7.19,0,0,0-1.65-2.46,6,6,0,0,0-2.33-1.41,8.14,8.14,0,0,0-5.28,0A6.12,6.12,0,0,0,955.1,437a7.48,7.48,0,0,0-1.65,2.46,9.29,9.29,0,0,0-.63,3.61V444a10.55,10.55,0,0,0,.63,3.88,7.59,7.59,0,0,0,1.65,2.57,6.22,6.22,0,0,0,2.34,1.45,7.65,7.65,0,0,0,5.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M977.08,455.41V432.08H981v9.73H993v-9.73h3.87v23.33H993V445.24H981v10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1004,455.41V432.08h3.88v9.73H1020v-9.73h3.87v23.33H1020V445.24h-12.06v10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1036.57,455.12a9.86,9.86,0,0,1-3.56-2.2,10.67,10.67,0,0,1-2.47-3.72,13.82,13.82,0,0,1-.92-5.24v-.88a12.64,12.64,0,0,1,.92-5,10.45,10.45,0,0,1,2.47-3.56,10.34,10.34,0,0,1,3.56-2.16,13,13,0,0,1,8.54,0,10.15,10.15,0,0,1,6,5.72,12.46,12.46,0,0,1,.93,5V444a13.62,13.62,0,0,1-.93,5.24,10.65,10.65,0,0,1-2.46,3.72,10,10,0,0,1-3.57,2.2,12.85,12.85,0,0,1-8.54,0Zm6.91-3.26a6.22,6.22,0,0,0,2.34-1.45,7.59,7.59,0,0,0,1.65-2.57,10.53,10.53,0,0,0,.64-3.88v-.88a9.29,9.29,0,0,0-.64-3.61,7.48,7.48,0,0,0-1.65-2.46,6.12,6.12,0,0,0-2.34-1.41,8.14,8.14,0,0,0-5.28,0,6,6,0,0,0-2.33,1.41,7.19,7.19,0,0,0-1.65,2.46,9.1,9.1,0,0,0-.64,3.61V444a10.33,10.33,0,0,0,.64,3.88,7.3,7.3,0,0,0,1.65,2.57,6.1,6.1,0,0,0,2.33,1.45,7.65,7.65,0,0,0,5.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1057.34,444.89v-3.61h13.2v3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1079.79,455.3a7.4,7.4,0,0,1-2.51-1.52,6.52,6.52,0,0,1-1.54-2.29,7.81,7.81,0,0,1-.52-2.91q0-3.48,2-5a9.64,9.64,0,0,1,5.88-1.54h7.57v-1.59c0-2-.45-3.41-1.34-4.16a6.17,6.17,0,0,0-4-1.12,5.64,5.64,0,0,0-3.65.95,3.21,3.21,0,0,0-1.28,2.13h-3.88a6,6,0,0,1,.78-2.62,6.77,6.77,0,0,1,1.84-2.09,9.06,9.06,0,0,1,2.8-1.39,12.35,12.35,0,0,1,3.61-.5,13.93,13.93,0,0,1,3.74.46,7.24,7.24,0,0,1,2.84,1.47,6.6,6.6,0,0,1,1.8,2.6,10.16,10.16,0,0,1,.64,3.83v9.46c0,1.24,0,2.32,0,3.24a26.57,26.57,0,0,0,.2,2.71h-3.39c-.08-.68-.14-1.32-.17-1.92s0-1.28,0-2a6.29,6.29,0,0,1-1.21,1.71,8.25,8.25,0,0,1-1.78,1.39,9.47,9.47,0,0,1-2.29.94,10.64,10.64,0,0,1-6.12-.19Zm6.8-3.35a6.48,6.48,0,0,0,2.14-1.1,5.09,5.09,0,0,0,1.45-1.8,5.54,5.54,0,0,0,.53-2.45V445h-6.91a5.79,5.79,0,0,0-3.39.86,3.06,3.06,0,0,0-1.23,2.7,3.5,3.5,0,0,0,1.16,2.69,5.41,5.41,0,0,0,3.68,1.06A8.59,8.59,0,0,0,1086.59,452Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1101.54,455.41V432.08h3.87v9.73h12.06v-9.73h3.87v23.33h-3.87V445.24h-12.06v10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1131.76,455.3a7.21,7.21,0,0,1-2.51-1.52,6.39,6.39,0,0,1-1.54-2.29,7.81,7.81,0,0,1-.53-2.91q0-3.48,2-5a9.59,9.59,0,0,1,5.87-1.54h7.57v-1.59c0-2-.44-3.41-1.34-4.16a6.17,6.17,0,0,0-4-1.12,5.64,5.64,0,0,0-3.65.95,3.25,3.25,0,0,0-1.28,2.13h-3.87a6.13,6.13,0,0,1,.77-2.62,6.81,6.81,0,0,1,1.85-2.09,9.11,9.11,0,0,1,2.79-1.39,12.4,12.4,0,0,1,3.61-.5,13.93,13.93,0,0,1,3.74.46,7.17,7.17,0,0,1,2.84,1.47,6.72,6.72,0,0,1,1.81,2.6,10.37,10.37,0,0,1,.64,3.83v9.46c0,1.24,0,2.32,0,3.24a21.87,21.87,0,0,0,.2,2.71h-3.39q-.14-1-.18-1.92c0-.6,0-1.28,0-2a6.76,6.76,0,0,1-1.21,1.71,8.56,8.56,0,0,1-1.79,1.39,9.39,9.39,0,0,1-2.28.94,10.11,10.11,0,0,1-2.73.36A9.88,9.88,0,0,1,1131.76,455.3Zm6.8-3.35a6.43,6.43,0,0,0,2.13-1.1,5.09,5.09,0,0,0,1.45-1.8,5.41,5.41,0,0,0,.53-2.45V445h-6.91a5.79,5.79,0,0,0-3.39.86,3.06,3.06,0,0,0-1.23,2.7,3.47,3.47,0,0,0,1.17,2.69,5.36,5.36,0,0,0,3.67,1.06A8.7,8.7,0,0,0,1138.56,452Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1152.07,455.82a3.25,3.25,0,0,1-.66-.11v-3.87a.57.57,0,0,0,.26.05h.4a2.52,2.52,0,0,0,1.71-.62,4.43,4.43,0,0,0,1.15-2.16,23.36,23.36,0,0,0,.66-4.18c.14-1.76.22-4,.22-6.69v-6.16h16.72v23.33h-3.87v-19.9h-9v3.61a60.31,60.31,0,0,1-.44,8.1,18.83,18.83,0,0,1-1.3,5.13,5.3,5.3,0,0,1-5.21,3.5Q1152.37,455.85,1152.07,455.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1179.64,455.41V432.08h3.88v17.6l12.06-17.6h3.87v23.33h-3.87V437.8l-12.06,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1212.16,455.41v-19.9h-8v-3.43H1224v3.43h-8v19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1228.75,455.41V432.08h3.88v17.6l12.06-17.6h3.87v23.33h-3.87V437.8l-12.06,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1269,455.41v-9.29a12.11,12.11,0,0,1-2.44,1.1,11.46,11.46,0,0,1-3.59.48,9.68,9.68,0,0,1-6.34-1.85q-2.24-1.85-2.24-6.29v-7.48h3.87v6.82c0,2,.41,3.37,1.23,4.14a6.06,6.06,0,0,0,4.14,1.14,12.85,12.85,0,0,0,3.39-.39,6.35,6.35,0,0,0,2-.84V432.08h3.87v23.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1285.74,455.14a9.67,9.67,0,0,1-3.57-2.18,10.65,10.65,0,0,1-2.46-3.72,13.69,13.69,0,0,1-.93-5.28v-.88a13.08,13.08,0,0,1,.89-5,10.33,10.33,0,0,1,2.35-3.56,9.42,9.42,0,0,1,3.43-2.14,12.09,12.09,0,0,1,4.12-.7q5.19,0,8,2.79t2.79,8v2.47h-17.69a8.17,8.17,0,0,0,.66,3.45,6.4,6.4,0,0,0,1.71,2.31,6.63,6.63,0,0,0,2.36,1.28,9.05,9.05,0,0,0,2.62.4,7.88,7.88,0,0,0,4.07-.88,5,5,0,0,0,2.05-2.43h3.78a7.75,7.75,0,0,1-1.25,3,8.45,8.45,0,0,1-2.2,2.14,10.25,10.25,0,0,1-3,1.3,13.7,13.7,0,0,1-3.5.44A12.88,12.88,0,0,1,1285.74,455.14Zm11-13.42a8,8,0,0,0-.6-3.06,5.33,5.33,0,0,0-1.47-2,5.94,5.94,0,0,0-2.18-1.12,10,10,0,0,0-2.66-.35,9.3,9.3,0,0,0-2.64.37,6.33,6.33,0,0,0-2.27,1.19,6.2,6.2,0,0,0-1.61,2,6.52,6.52,0,0,0-.61,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1311.24,455.12a8.78,8.78,0,0,1-3.34-2.2,10.37,10.37,0,0,1-2.23-3.72,15.42,15.42,0,0,1-.81-5.24v-.88a13,13,0,0,1,.88-5,10.58,10.58,0,0,1,2.33-3.56,9.73,9.73,0,0,1,3.37-2.16,11.18,11.18,0,0,1,4-.72,11.35,11.35,0,0,1,3.72.57,9,9,0,0,1,2.86,1.58,8.53,8.53,0,0,1,2,2.38,10.29,10.29,0,0,1,1.12,2.95h-4a8,8,0,0,0-2-2.82,5.47,5.47,0,0,0-3.77-1.14,6.67,6.67,0,0,0-2.46.46,6,6,0,0,0-2.12,1.41,7,7,0,0,0-1.47,2.44,10.42,10.42,0,0,0-.55,3.61V444a11.82,11.82,0,0,0,.55,3.85,7.29,7.29,0,0,0,1.47,2.6,5.59,5.59,0,0,0,2.12,1.45,6.68,6.68,0,0,0,2.46.47,6.09,6.09,0,0,0,3.63-1.06,5.63,5.63,0,0,0,2.09-2.91h4a9.75,9.75,0,0,1-1.27,3.11,9.09,9.09,0,0,1-2.14,2.35,9.29,9.29,0,0,1-2.84,1.5,10.82,10.82,0,0,1-3.43.53A11.92,11.92,0,0,1,1311.24,455.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1330.62,455.41V432.08h3.88v9.77h3.08l8.71-9.77h4.58l-10.12,11.18,10.56,12.15h-4.93l-8.8-10.21h-3.08v10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1356.14,455.41V432.08H1360v17.6l12.06-17.6H1376v23.33h-3.87V437.8L1360,455.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1383.08,455.41V432.08H1387v17.6l12.06-17.6h3.88v23.33H1399V437.8L1387,455.41Zm4.88-27.67a5.54,5.54,0,0,1-1.58-4.25h3.79a3.18,3.18,0,0,0,.7,2.25,2.76,2.76,0,0,0,2.11.75,2.9,2.9,0,0,0,2.18-.75,3.09,3.09,0,0,0,.73-2.25h3.7a5.51,5.51,0,0,1-1.59,4.25q-1.59,1.49-5,1.48T1388,427.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1439.9,460.91v-5.5h-19V432.08h3.88V452H1436V432.08h3.87V452h3.74v8.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1453.58,455.14A9.67,9.67,0,0,1,1450,453a10.65,10.65,0,0,1-2.46-3.72,13.7,13.7,0,0,1-.92-5.28v-.88a13.09,13.09,0,0,1,.88-5,10.33,10.33,0,0,1,2.35-3.56,9.42,9.42,0,0,1,3.43-2.14,12.09,12.09,0,0,1,4.12-.7q5.19,0,8,2.79t2.79,8v2.47H1450.5a8.17,8.17,0,0,0,.66,3.45,6.31,6.31,0,0,0,1.72,2.31,6.5,6.5,0,0,0,2.35,1.28,9.05,9.05,0,0,0,2.62.4,7.86,7.86,0,0,0,4.07-.88,5,5,0,0,0,2-2.43h3.78a7.75,7.75,0,0,1-1.25,3,8.45,8.45,0,0,1-2.2,2.14,10.25,10.25,0,0,1-3,1.3,13.7,13.7,0,0,1-3.5.44A12.88,12.88,0,0,1,1453.58,455.14Zm11-13.42a8,8,0,0,0-.6-3.06,5.33,5.33,0,0,0-1.47-2,5.86,5.86,0,0,0-2.18-1.12,9.94,9.94,0,0,0-2.66-.35,9.3,9.3,0,0,0-2.64.37,6.41,6.41,0,0,0-2.27,1.19,6.33,6.33,0,0,0-1.61,2,6.52,6.52,0,0,0-.61,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1474,455.41V432.08h3.87v9.73H1490v-9.73h3.87v23.33H1490V445.24h-12.06v10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1506.56,455.41v-19.9h-8v-3.43h19.81v3.43h-8v19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1523.14,464.21V432.08h3.61v4.4a8.55,8.55,0,0,1,3.32-3.59,9.68,9.68,0,0,1,5-1.25,9.1,9.1,0,0,1,7,2.88c1.76,1.92,2.64,4.78,2.64,8.56V444a17.39,17.39,0,0,1-.71,5.2,10.33,10.33,0,0,1-2,3.71,8.13,8.13,0,0,1-3.06,2.23,10,10,0,0,1-3.94.75,8.47,8.47,0,0,1-8-4.62v13Zm13.65-12.35a5.93,5.93,0,0,0,2.13-1.6,7.68,7.68,0,0,0,1.41-2.65,11.87,11.87,0,0,0,.51-3.65v-.88a10.41,10.41,0,0,0-.51-3.41,7.55,7.55,0,0,0-1.41-2.51,5.82,5.82,0,0,0-2.13-1.56,6.73,6.73,0,0,0-2.64-.53,8,8,0,0,0-2.91.51A6.45,6.45,0,0,0,1529,437a6.75,6.75,0,0,0-1.45,2.14,6.65,6.65,0,0,0-.52,2.64v3.52a7.81,7.81,0,0,0,.52,2.91,6.57,6.57,0,0,0,1.45,2.24,6.73,6.73,0,0,0,2.25,1.46,7.81,7.81,0,0,0,2.91.52A6.41,6.41,0,0,0,1536.79,451.86Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnLight);
export default __webpack_public_path__ + "static/media/logo-on-light.9a3b3471b68e7fbff4c2fd07a2b4c92d.svg";
export { ForwardRef as ReactComponent };